(ns app.front.ui.photo-select
  (:require ["@carbon/icons-react/es/close/24" :default Close24]
            [app.front.file.download :as file-download]
            [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.util.util :as util]
            [potpuri.core :as p]))


(defn deselect-all-photos-disabled? [selected-photo-ids available-photos]
  (boolean (or (nil? selected-photo-ids)
               (not-any? selected-photo-ids (map :db/id available-photos)))))


(defn select-all-photos-disabled? [selected-photo-ids available-photos]
  (every? selected-photo-ids (map :db/id available-photos)))


(defn photo-item
  [{:keys [photo selected-photo-ids on-select on-remove download-command label-fn img-alt-fn]}]
  (let [photo-id  (:db/id photo)
        selected? (some #(= photo-id %) selected-photo-ids)]
    [:div.rounded-t.media-item
     {:class (if selected? "attachment-item-selected" "attachment-item-unselected")}
     [:div.flex.flex-column.relative.w-full.cursor-pointer
      [:img.w-full.h-48.object-cover.block
       (p/assoc-if
         {:on-click #(on-select photo-id)
          :src      (file-download/download-href download-command
                                                 {"file-id" photo-id
                                                  "preview" true})}
         :alt (when img-alt-fn (img-alt-fn photo)))]
      (when selected?
        [:span.absolute.bg-violet-diagonal.w-14.h-16.right-0.w-16.text-right.pr-2.pt-2.cursor-pointer.text-white
         {:on-click #(on-remove photo-id)}
         [:> Close24]])]
     (when label-fn
       [:div.relative.w-full.p-3.bg-ui-violet-100.text-white.h-14
        [:div.truncate.h-10 (label-fn photo)]])]))


(defn photo-select
  "Component for selecting photos from a set of available photos. Selection state is handled externally.

  Options
  `:on-select-all` select all button callback (required)
  `:on-remove-all` deselect all button callback (required)
  `:on-done` done button callback for handling selector close (optional)
  `:available-photos` file entities to select from (required)
  `:selected-photo-ids` set of entity ids of currently selected photos (required)
  `:title` selector title string (optional)

  Options passed to each photo
  `:on-select` callback for selection of single photo, called with id (required)
  `:on-remove` callback for de-selection of single photo, called with id (required)
  `:download-command` command used for downloading image for preview (required)
  `label-fn` function for rendering the label of a single photo, called with entity (optional)
  `img-alt-fn` function for creating img alt parameter, called with entity (optional)"
  [{:keys [tr on-select-all on-remove-all on-done available-photos selected-photo-ids title] :as props}]
  (let [photo-count (count available-photos)]
    (when (> photo-count 0)
      [:div.photo-media-wrapper-item.pb-6.ml-2
       (when title [:div.h3.bold.pb-2 title])
       [:div.pb-3
        (cc/button {:kind       :tertiary
                    :size       :small
                    :disabled   (deselect-all-photos-disabled? selected-photo-ids available-photos)
                    :class-name "mr-2 mt-2"
                    :on-click   on-remove-all}
                   (tr [:multi-select/select-none]))
        (cc/button {:kind       :tertiary
                    :size       :small
                    :disabled   (select-all-photos-disabled? selected-photo-ids available-photos)
                    :class-name "mr-2 mt-2"
                    :on-click   on-select-all}
                   (tr [:multi-select/select-all]))
        (when on-done
          (cc/button {:kind       :primary
                      :size       :small
                      :class-name "mt-2"
                      :on-click   on-done}
                     (tr [:done])))]
       [:div.photo-media-items
        (futil/for-frag [photo available-photos]
          [photo-item (merge props
                             (util/mmap photo))])]])))
